import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Portfolio from "./components/portfolio/Portfolio";
import ResumeViewer from "./components/resume/ResumeViewer";

const APP_ROUTE_SEGMENTS = new Set([
  "home",
  "projects",
  "blogs",
  "blog",
  "quiz",
  "contact",
  "resume-viewer",
]);

const getRouterBasename = () => {
  const publicUrl = process.env.PUBLIC_URL || "";
  if (publicUrl) {
    try {
      const publicPath = new URL(publicUrl, window.location.origin).pathname;
      return publicPath === "/" ? undefined : publicPath.replace(/\/$/, "");
    } catch (error) {
      return publicUrl.replace(/\/$/, "") || undefined;
    }
  }

  const firstPathSegment = window.location.pathname.split("/").filter(Boolean)[0];
  return firstPathSegment && !APP_ROUTE_SEGMENTS.has(firstPathSegment)
    ? `/${firstPathSegment}`
    : undefined;
};

const App = () => {
  const routerBasename = getRouterBasename();

  return (
    <Router basename={routerBasename}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Portfolio section="home" />} />
        <Route path="/projects" element={<Portfolio section="projects" />} />
        <Route
          path="/projects/:categorySlug"
          element={<Portfolio section="projects" />}
        />
        <Route
          path="/projects/:categorySlug/:projectSlug"
          element={<Portfolio section="projects" />}
        />
        {/* RESUME route commented out to avoid showing up in the nav bar*/}
        {/* <Route path="/resume" element={<Portfolio section="resume" />} /> */}
        {/* CV route commented out - using Resume as primary term for North American market */}
        {/* <Route path="/CV" element={<Portfolio section="CV" />} /> */}
        <Route path="/blogs" element={<Portfolio section="Blogs" />} />
        <Route path="/blog/:postSlug" element={<Portfolio section="Blogs" />} />
        <Route path="/quiz" element={<Portfolio section="quiz" />} />
        <Route
          path="/quiz/:categorySlug"
          element={<Portfolio section="quiz" />}
        />
        <Route
          path="/quiz/:categorySlug/:sectionSlug"
          element={<Portfolio section="quiz" />}
        />
        <Route
          path="/quiz/:categorySlug/:sectionSlug/:quizSlug"
          element={<Portfolio section="quiz" />}
        />
        <Route path="/contact" element={<Portfolio section="contact" />} />
        <Route path="/resume-viewer" element={<ResumeViewer />} />
      </Routes>
      <Analytics />
    </Router>
  );
};

export default App;
